var T = function (k, f) { var d = typeof window !== 'undefined' && window.VP_I18N; return d && typeof d[k] === 'string' ? d[k] : f; }; // vp-i18n T()
/* R40: product views, loaded only after an explicit choice. No autoplay or storage. */
(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root.document) {
    if (root.document.readyState === "loading") root.document.addEventListener("DOMContentLoaded", function () { api.mount(root); }, { once: true });
    else api.mount(root);
  }
})(typeof window === "undefined" ? {} : window, function () {
  "use strict";
  var LOAD_TIMEOUT = 25000;

  function createGallery(win, root) {
    if (root.__vpEditionGallery) return root.__vpEditionGallery;
    var image = root.querySelector("[data-edition-image]");
    var group = root.querySelector("[data-edition-thumbnails]");
    var buttons = Array.from(root.querySelectorAll("button[data-edition-src]"));
    if (!image || !buttons.length || typeof win.Image !== "function") return null;
    var caption = root.querySelector("[data-edition-caption-output]");
    var status = root.querySelector("[data-edition-status]");
    var previous = root.querySelector("[data-edition-prev]");
    var next = root.querySelector("[data-edition-next]");
    var listeners = [], pending = null, sequence = 0, disposed = false, initialTimer = null, choiceError = false;
    var madeStatus = !status;
    if (!status) {
      status = win.document.createElement("p");
      status.setAttribute("data-edition-status", "");
      root.appendChild(status);
    }
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.setAttribute("aria-atomic", "true");

    function absolute(src) {
      try { return new URL(src, win.document.baseURI || win.location.href).href; }
      catch (_) { return src; }
    }
    var views = buttons.map(function (button) {
      return { button: button, src: (button.dataset.editionSrc || "").trim(),
        srcset: (button.dataset.editionSrcset || "").trim(), sizes: (button.dataset.editionSizes || "").trim(),
        width: Number(button.dataset.editionWidth) || 0, height: Number(button.dataset.editionHeight) || 0,
        alt: button.dataset.editionAlt || image.getAttribute("alt") || "Product view",
        caption: button.dataset.editionCaption || "",
        label: (button.textContent || "").trim() || button.dataset.editionCaption || "Product view" };
    });
    var selected = views.findIndex(function (view) { return absolute(view.src) === absolute(image.getAttribute("src") || image.src); });
    // Unknown initial images remain visible, but no thumbnail falsely claims selection.
    var target = selected;
    var controls = [group, previous, next].filter(Boolean);
    var initialHidden = controls.map(function (control) { return control.hidden; });
    var originalAspectRatio = image.style.aspectRatio;
    function reserveSpace() {
      if (image.style.aspectRatio) return;
      var width = Number(image.getAttribute("width")) || image.naturalWidth;
      var height = Number(image.getAttribute("height")) || image.naturalHeight;
      if (width > 0 && height > 0) image.style.aspectRatio = width + " / " + height;
    }
    reserveSpace();
    function listen(node, type, handler) {
      if (!node) return;
      node.addEventListener(type, handler);
      listeners.push(function () { node.removeEventListener(type, handler); });
    }
    function state(value, message) {
      root.dataset.editionState = value;
      root.setAttribute("aria-busy", String(value === "loading"));
      status.textContent = message || "";
    }
    function imageReady() {
      return !!(image.complete && image.naturalWidth > 0 && image.naturalHeight > 0);
    }
    function clearInitialTimer() {
      if (initialTimer !== null) win.clearTimeout(initialTimer);
      initialTimer = null;
    }
    function inspectDisplayedImage() {
      if (disposed || pending || choiceError) return;
      clearInitialTimer();
      if (imageReady()) {
        // Keep a successful explicit-choice announcement when its DOM load follows.
        if (root.dataset.editionState !== "ready") state("ready", "");
      } else if (image.complete) {
        state("error", T('js.edition.initial_error', "This image could not load. Select a view to try again."));
      } else {
        state("loading", T('js.edition.loading_initial', "Loading product image…"));
        var token = sequence;
        var timer = win.setTimeout(function () {
          if (initialTimer === timer) initialTimer = null;
          if (disposed || pending || token !== sequence) return;
          if (imageReady()) state("ready", "");
          else state("error", T('js.edition.initial_error', "This image could not load. Select a view to try again."));
        }, LOAD_TIMEOUT);
        initialTimer = timer;
      }
    }
    function failureMessage(label) {
      return T('js.edition.fail_prefix', "Could not load ") + label + T('js.edition.fail_suffix', ". ") + (imageReady() ? T('js.edition.fail_previous', "The previous image is still shown. ") : "") +
        T('js.edition.fail_retry', "Select the view to try again.");
    }
    function sync() {
      views.forEach(function (view, index) {
        view.button.setAttribute("aria-pressed", String(index === selected));
        view.button.disabled = !view.src;
      });
      if (previous) previous.disabled = target <= 0;
      if (next) next.disabled = target >= views.length - 1;
    }
    function cancel() {
      sequence++;
      clearInitialTimer();
      if (!pending) return;
      pending.loader.onload = pending.loader.onerror = null;
      win.clearTimeout(pending.timer);
      pending = null;
    }
    function choose(index) {
      if (disposed || index < 0 || index >= views.length || !views[index].src) return;
      if (pending && target === index) return;
      cancel();
      choiceError = false;
      target = index;
      sync();
      // URL equality does not prove that the first image actually loaded.
      if (index === selected && imageReady()) { state("ready", ""); return; }
      var view = views[index], token = sequence;
      var loader;
      try { loader = new win.Image(); }
      catch (_) { choiceError = true; target = selected; sync(); state("error", failureMessage(view.label)); return; }
      var request = { loader: loader, timer: null };
      pending = request;
      function current() { return !disposed && token === sequence && pending === request; }
      function release() {
        loader.onload = loader.onerror = null;
        win.clearTimeout(request.timer);
        pending = null;
      }
      function failed() {
        if (!current()) return;
        release();
        choiceError = true;
        target = selected;
        sync();
        state("error", failureMessage(view.label));
      }
      function commit() {
        if (!current()) return;
        release();
        reserveSpace();
        // Apply the selected view's authored candidates before changing src.
        // A view without candidates must clear both attributes from the old view.
        if (view.srcset) {
          image.setAttribute("sizes", view.sizes || "100vw");
          image.setAttribute("srcset", view.srcset);
        } else {
          image.removeAttribute("srcset");
          image.removeAttribute("sizes");
        }
        if (view.width > 0 && view.height > 0) {
          image.setAttribute("width", String(view.width));
          image.setAttribute("height", String(view.height));
        }
        image.setAttribute("src", view.src);
        image.setAttribute("alt", view.alt);
        if (caption) caption.textContent = view.caption;
        selected = target = index;
        sync();
        state("ready", view.label + T('js.edition.shown_suffix', " view shown."));
      }
      loader.decoding = "async";
      // Explicit Liquid-generated candidates; never infer resized CDN paths.
      if (view.srcset) { loader.sizes = view.sizes || "100vw"; loader.srcset = view.srcset; }
      loader.onload = function () {
        if (!current()) return;
        if (!loader.naturalWidth || !loader.naturalHeight) { failed(); return; }
        if (typeof loader.decode !== "function") { commit(); return; }
        try { Promise.resolve(loader.decode()).then(commit, failed); }
        catch (_) { failed(); }
      };
      loader.onerror = failed;
      request.timer = win.setTimeout(failed, LOAD_TIMEOUT);
      state("loading", T('js.edition.loading_prefix', "Loading ") + view.label + T('js.edition.loading_suffix', "…"));
      try { loader.src = view.src; } catch (_) { failed(); }
    }
    views.forEach(function (view, index) {
      listen(view.button, "click", function (event) { event.preventDefault(); choose(index); });
    });
    listen(previous, "click", function (event) { event.preventDefault(); choose(target - 1); });
    listen(next, "click", function (event) { event.preventDefault(); choose(target + 1); });
    listen(group, "keydown", function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || (event.key !== "ArrowLeft" && event.key !== "ArrowRight")) return;
      var button = event.target.closest && event.target.closest("button[data-edition-src]");
      var index = buttons.indexOf(button);
      if (index < 0 || !group.contains(button)) return;
      var direction = event.key === "ArrowLeft" ? -1 : 1;
      var destination = index + direction;
      while (destination >= 0 && destination < views.length && !views[destination].src) destination += direction;
      if (destination < 0 || destination >= views.length) return;
      event.preventDefault();
      buttons[destination].focus({ preventScroll: true });
      choose(destination);
    });
    listen(image, "load", function () { reserveSpace(); inspectDisplayedImage(); });
    listen(image, "error", inspectDisplayedImage);
    controls.forEach(function (control) { control.hidden = false; });
    sync();
    inspectDisplayedImage();
    root.dataset.editionGalleryMounted = "true";
    var controller = {
      choose: choose,
      suspend: function () {
        if (disposed) return;
        cancel(); target = selected; sync();
        if (choiceError) return;
        state(imageReady() ? "ready" : "error", imageReady() ? "" : T('js.edition.suspend_error', "Select a view to load the product image."));
      },
      dispose: function () {
        if (disposed) return;
        disposed = true;
        cancel();
        listeners.forEach(function (remove) { remove(); });
        controls.forEach(function (control, index) { control.hidden = initialHidden[index]; });
        image.style.aspectRatio = originalAspectRatio;
        root.removeAttribute("aria-busy");
        delete root.dataset.editionGalleryMounted;
        delete root.dataset.editionState;
        delete root.__vpEditionGallery;
        if (madeStatus) status.remove();
      }
    };
    root.__vpEditionGallery = controller;
    return controller;
  }

  function mount(win) {
    if (win.__vpEditionGalleries) { win.__vpEditionGalleries.refresh(); return win.__vpEditionGalleries; }
    var entries = [], disposed = false;
    function refresh() {
      if (disposed) return;
      win.document.querySelectorAll("[data-edition-gallery]").forEach(function (root) {
        var gallery = createGallery(win, root);
        if (gallery && !entries.includes(gallery)) entries.push(gallery);
      });
    }
    function pagehide(event) {
      if (event.persisted) entries.forEach(function (gallery) { gallery.suspend(); });
      else controller.dispose();
    }
    var controller = {
      refresh: refresh,
      dispose: function () {
        if (disposed) return;
        disposed = true;
        entries.forEach(function (gallery) { gallery.dispose(); });
        win.removeEventListener("pagehide", pagehide);
        delete win.__vpEditionGalleries;
      }
    };
    win.__vpEditionGalleries = controller;
    win.addEventListener("pagehide", pagehide);
    refresh();
    return controller;
  }
  return { mount: mount, createGallery: createGallery, LOAD_TIMEOUT: LOAD_TIMEOUT };
});
